module.exports = __webpack_public_path__ + "img/vn.7de4d736.svg";